import { Component, Input, OnInit } from '@angular/core';
import { Notification } from '../models/notification.model';
import { NotificationService } from '../services/notification.service';
import { LoginService } from '@ebw-monorepo/login';

@Component({
  selector: 'ebw-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  @Input() notification: Notification;

  isRead: boolean = false;

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.isRead = this.notification.read
      .map((el) => el.user_id)
      .includes(sessionStorage.getItem(LoginService.USER_ID_KEY));
  }

  readNotification(id: string) {
    this.notificationService.read(id)?.subscribe({
      next: (resp: any) => {
        this.notification.read.push(resp);
        this.notificationService.refreshCount();
        this.isRead = true;
      },
      error: (e) => console.error('[NotificationService][read]', e)
    });
  }

  download = (notification: Notification) => this.notificationService.downloadNotificationContent(notification);
}
